/* If the shipping threshold metaobject exists, it will replace the default or the market's metafields displayed in the announcement */
(() => {
  try {
    /* Get active currency */
    const shopCurrencyActive = Shopify.currency.active;

    /* Get countries iso codes of the predefined shipping threshold currencies */
    const shippingThresholdElement = document.querySelector('#shipping-thresholds');
    const shippingThresholdObject = JSON.parse(shippingThresholdElement.innerHTML);

    // Get all threshold html elements
    const freeShippingTexts = document.querySelectorAll('.shipping-threshold_value');

    // Update all threshold html elements if the store's active currency matches one from the object
    Object.entries(shippingThresholdObject).forEach(([currencyCode, currencyObject]) => {
      if (shopCurrencyActive === currencyCode) {
        freeShippingTexts.forEach(element => {
          element.innerHTML = `${Math.trunc(currencyObject.threshold)} ${
            currencyObject.currency
          }`;
        });
      }
    });
  } catch (error) {
    console.error('An error occurred:', error.message);
  }
})();

/* Update Rebuy cart shipping threshold */

const freeShippingText = document.querySelector('.js-freeshipping-text');

const handleRebuyCartMutation = () => {
  const rebuyCart = document.querySelector('#rebuy-cart');
  if (rebuyCart && Shopify?.locale === 'en') {
    const rebuyText = document.querySelector('.free-shipping_announcement');
    if (!rebuyText) return;
    rebuyText.innerHTML = freeShippingText.innerHTML;
    observer.disconnect(); // Disconnect the observer once the element is found
  }
};

const observer = new MutationObserver(handleRebuyCartMutation);

document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.body, { childList: true, subtree: true });
});
